import { Translation } from '../types';

export const lv: Translation = {
  common: {
    loading: 'Ielādē...',
    error: 'Kļūda',
    cancel: 'Atcelt',
    save: 'Saglabāt',
    close: 'Aizvērt',
    search: 'Meklēt',
    reload: 'Pārlādēt',
    logout: 'Iziet',
    dashboard: 'Vadības panelis',
    products: 'Produkti',
    settings: 'Iestatījumi',
    language: 'Valoda',
    businessHours: 'Darba laiks',
    back: 'Atpakaļ',
    selectAll: 'Atlasīt visu',
    deselectAll: 'Atcelt atlasi',
    success: 'Veiksmīgi',
    selected: 'Atlasīts',
    confirm: 'Apstiprināt',
    required: 'Obligāts',
    requiredMarker: '*',
    previous: 'Iepriekšējais',
    next: 'Nākamais',
    allRightsReserved: 'Visas tiesības aizsargātas.',
  },
  auth: {
    login: 'Pieteikties',
    email: 'E-pasta adrese',
    password: 'Parole',
    loginButton: 'Pieteikties',
    loggingIn: 'Notiek pieteikšanās...',
    loginSuccess: 'Pieteikšanās veiksmīga',
    loginError: 'E-pasts vai parole ir nepareiza',
    invalidEmail: 'Lūdzu, ievadiet derīgu e-pasta adresi',
    requiredFields: 'Lūdzu, ievadiet e-pastu un paroli',
    demoAccount: 'Demo konts:',
    loginDescription: 'Ievadiet sava konta informāciju, lai pieteiktos',
    welcomeMessage: 'Laipni lūdzam biznesa pasūtījumu sistēmā',
    // Registration
    register: 'Reģistrēties',
    createAccount: 'Izveidot kontu',
    confirmPassword: 'Apstiprināt paroli',
    passwordRequirements: 'Parolei jābūt vismaz 8 rakstzīmēm ar lielajiem, mazajiem burtiem, ciparu un speciālo rakstzīmi',
    passwordsDoNotMatch: 'Paroles nesakrīt',
    registrationSuccess: 'Reģistrācija veiksmīga',
    registrationDescription: 'Reģistrējieties biznesa kontam',
    alreadyHaveAccount: 'Jau ir konts?',
    signIn: 'Pierakstīties',
    dontHaveAccount: "Nav konta?",
    creatingAccount: 'Veido kontu...',
    registrationNote: 'Piezīme:',
    registrationNotePoints: {
      erpLinking: 'Ja jums ir esošs biznesa konts, jūsu e-pasts tiks automātiski saistīts',
      companyEmail: 'Lūdzu, izmantojiet sava uzņēmuma e-pasta adresi reģistrācijai',
      contactSupport: 'Sazinieties ar atbalstu, ja jums nepieciešama palīdzība reģistrācijā'
    },
    b2bUsers: 'Biznesa konta lietotāji:',
    registeredEmail: 'Reģistrētā e-pasta adrese',
    registeredPassword: 'Reģistrācijas laikā iestatītā parole',
    b2bCustomerRequired: 'Šī e-pasta adrese nav reģistrēta kā biznesa klients. Lūdzu, vispirms sazinieties ar pārdošanas nodaļu, lai izveidotu biznesa attiecības.',
    b2bVerificationError: 'Nevar pārbaudīt biznesa klienta statusu. Lūdzu, sazinieties ar atbalstu.',
    // Password Reset
    passwordReset: 'Paroles atiestatīšana',
    passwordResetDescription: 'Ievadiet savu e-pasta adresi, lai saņemtu pagaidu paroli',
    getTemporaryPassword: 'Saņemt pagaidu paroli',
    processing: 'Apstrādā...',
    passwordResetComplete: 'Paroles atiestatīšana pabeigta',
    temporaryPasswordGenerated: 'Pagaidu parole ir ģenerēta',
    temporaryPassword: 'Pagaidu parole',
    backToLogin: 'Atpakaļ uz pieteikšanos',
    securityNotice: 'Drošības paziņojums:',
    securityNotePoints: {
      keepSecret: 'Nedalieties ar pagaidu paroli ar citiem',
      changeAfterLogin: 'Noteikti nomainiet paroli pēc pieteikšanās',
      expires24Hours: 'Pagaidu parole beigsies pēc 24 stundām'
    },
    resetNote: 'Piezīme:',
    resetNotePoints: {
      registeredEmail: 'Ievadiet savu reģistrēto e-pasta adresi',
      passwordDisplayed: 'Pagaidu parole tiks parādīta ekrānā',
      changeRequired: 'Pēc pieteikšanās nepieciešama paroles maiņa'
    },
    copied: 'Nokopēts',
    copySuccessMessage: 'Pagaidu parole nokopēta starpliktuvē.',
    forgotPassword: 'Aizmirsi paroli?',
    // Password Reset Email Request
    sendResetLink: 'Sūtīt atiestatīšanas saiti',
    sendingEmail: 'Sūta e-pastu...',
    emailSent: 'E-pasts nosūtīts',
    emailSentMessage: 'Ja šī e-pasta adrese pastāv mūsu sistēmā, drīz saņemsiet paroles atiestatīšanas saiti.',
    emailNotSent: 'E-pasts nav nosūtīts',
    emailSentInfo: 'Pārbaudiet savu e-pasta iesūtni un surogātpasta mapi',
    checkEmail: 'Pārbaudīt e-pastu',
    emailInstructions: 'Paroles atiestatīšanas instrukcijas ir nosūtītas',
    nextSteps: 'Nākamie soļi:',
    nextStepsList: {
      checkInbox: 'Pārbaudiet savu e-pasta iesūtni un surogātpasta mapi',
      clickLink: 'Noklikšķiniet uz atiestatīšanas saites e-pastā',
      linkExpires: 'Saite beigsies pēc 24 stundām',
      contactSupport: 'Sazinieties ar atbalstu, ja nesaņemat e-pastu',
      rateLimitInfo: 'Ierobežots līdz 3 pieprasījumiem stundā'
    },
    // Password Reset Completion
    resetLinkSent: 'Atiestatīšanas saite nosūtīta',
    resetSuccess: 'Parole veiksmīgi atiestatīta',
    passwordUpdated: 'Parole atjaunināta',
    passwordUpdateMessage: 'Jūsu parole ir veiksmīgi atjaunināta. Tagad varat pieteikties ar savu jauno paroli.',
    loginWithNewPassword: 'Pieteikties ar jauno paroli',
    // Reset Token Page
    resetToken: 'Atiestatīt paroli',
    invalidToken: 'Nederīgs atiestatīšanas marķieris',
    expiredToken: 'Atiestatīšanas marķieris ir beidzies',
    tokenValid: 'Atiestatīšanas marķieris ir derīgs',
    newPassword: 'Jaunā parole',
    confirmNewPassword: 'Apstiprināt jauno paroli',
    updatePassword: 'Atjaunināt paroli',
    updatingPassword: 'Atjaunina paroli...',
    passwordMismatch: 'Paroles nesakrīt',
    resetInstructions: 'Ievadiet savu jauno paroli, lai pabeigtu atiestatīšanu',
  },
  accountInfo: {
    title: 'Konta informācija',
    loading: 'Ielādē konta informāciju...',
    error: 'Kļūda',
    errorMessage: 'Neizdevās iegūt konta informāciju',
    back: 'Atpakaļ',
    basicInfo: 'Pamatinformācija',
    name: 'Vārds',
    email: 'E-pasta adrese',
    contactId: 'Knitido klienta ID',
    contactNumber: 'Kontakta numurs',
    noInfo: 'Nav informācijas',
    companyInfo: 'Uzņēmuma informācija',
    company: 'Uzņēmuma nosaukums',
    position: 'Amats',
    vatId: 'PVN reģ. Nr.',
    billingAddress: 'Norēķinu adrese',
    deliveryAddress: 'Piegādes adrese',
    addressInfo: 'Adreses informācija',
    billingDescription: 'Adrese rēķiniem un līguma dokumentiem',
    deliveryDescription: 'Standarta piegādes adrese produktu sūtījumiem',
    sameAsBilling: '※ Tāda pati kā norēķinu adrese',
    sameAsDelivery: '※ Tāda pati kā piegādes adrese',
    companyName: 'Uzņēmuma nosaukums',
    contactPerson: 'Kontaktpersona',
    address: 'Adrese',
    phoneNumber: 'Tālruņa numurs',
    billingUsage: 'Izmanto kā galamērķi rēķiniem, līgumiem un citiem svarīgiem dokumentiem',
    deliveryUsage: 'Izmanto kā standarta piegādes adresi pasūtītajiem produktiem',
    alsoUsedForDelivery: 'Izmanto arī kā piegādes galamērķi',
    accountType: 'Konta tips',
    addressId: 'Adreses ID',
    // Address editing functionality
    edit: 'Rediģēt',
    editDeliveryAddress: 'Rediģēt piegādes adresi',
    editDeliveryDescription: 'Atjaunināt savu piegādes adreses informāciju',
    newDeliveryAddress: 'Pievienot jaunu piegādes adresi',
    newDeliveryDescription: 'Ievadiet jaunās piegādes adreses informāciju',
    noDeliveryAddress: 'Nav konfigurēta piegādes adrese',
    success: 'Veiksmīgi',
    addressUpdated: 'Piegādes adrese veiksmīgi atjaunināta',
    updateError: 'Neizdevās atjaunināt piegādes adresi',
    requiredFields: 'Lūdzu, aizpildiet visus obligātos laukus',
    firstName: 'Vārds',
    lastName: 'Uzvārds',
    streetAddress: 'Ielas adrese',
    streetAddress2: 'Ielas adrese 2',
    city: 'Pilsēta',
    country: 'Valsts',
    selectCountry: 'Izvēlieties valsti',
    searchCountry: 'Meklēt valsti...',
    noCountryFound: 'Valsts nav atrasta.',
    postalCode: 'Pasta indekss',
    companyNamePlaceholder: 'Ievadiet uzņēmuma nosaukumu',
    firstNamePlaceholder: 'Vārds',
    lastNamePlaceholder: 'Uzvārds',
    streetAddressPlaceholder: 'Ievadiet ielas adresi',
    streetAddress2Placeholder: 'Dzīvoklis, apartamenti utt.',
    cityPlaceholder: 'Ievadiet pilsētu',
    postalCodePlaceholder: 'Ievadiet pasta indeksu',
    billingNotEditable: 'Norēķinu adresi nevar rediģēt.',
    billingContactSupport: 'Sazinieties ar atbalstu izmaiņām.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} piegādes adreses',
    noDeliveryAddresses: 'Nav reģistrētu piegādes adrešu',
    defaultAddress: 'Noklusējuma',
    selectDeliveryAddress: 'Izvēlieties piegādes adresi',
    addNewAddress: 'Pievienot jaunu adresi',
    editAddress: 'Rediģēt adresi',
    deleteAddress: 'Dzēst adresi',
    confirmDelete: 'Apstiprināt dzēšanu',
    confirmDeleteMessage: 'Vai tiešām vēlaties dzēst šo adresi? Šo darbību nevar atsaukt.',
    addressAddedSuccess: 'Piegādes adrese pievienota',
    addressDeletedSuccess: 'Piegādes adrese izdzēsta',
    deleteError: 'Neizdevās izdzēst piegādes adresi',
    saving: 'Saglabā...',
    cancel: 'Atcelt',
    saveChanges: 'Saglabāt izmaiņas',
    selectedDeliveryAddress: 'Izvēlētā piegādes adrese',
  },
  dashboard: {
    title: 'Biznesa partneris',
    subtitle: 'Produktu pasūtīšanas sistēma',
    welcome: 'Laipni lūdzam,',
    welcomeMessage: 'Laipni lūdzam biznesa partnera pasūtījumu sistēmā. Šeit varat pasūtīt produktus.',
    productCatalog: 'Produktu katalogs',
    productCatalogDesc: 'Pārlūkojiet un pasūtiet pieejamos produktus',
    viewProducts: 'Skatīt produktus',
    orderHistory: 'Pasūtījumu vēsture',
    orderHistoryDesc: 'Skatīt iepriekšējos pasūtījumus (drīzumā)',
    accountSettings: 'Konta iestatījumi',
    accountSettingsDesc: 'Pārvaldīt konta informāciju (drīzumā)',
    comingSoon: 'Drīzumā',
    infoTitle: 'Par lietošanu',
    orderingInfo: 'Produktu pasūtīšana',
    orderingDesc: 'Izvēlieties produktus no kataloga un norādiet izmēru un krāsu. Pieejama reāllaika krājumu informācija.',
    supportInfo: 'Atbalsts',
    supportDesc: 'Ja jums ir kādi jautājumi, lūdzu, sazinieties ar mums.',
    viewOrderHistory: 'Skatīt pasūtījumu vēsturi',
    viewOrders: 'Skatīt pasūtījumus',
    accountInfo: 'Konta informācija',
    accountInfoDesc: 'Skatīt sava konta informāciju',
    viewDetails: 'Skatīt detaļas',
    supportEmail: 'b2b-partner@knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Pirmdiena-piektdiena 9:00 - 15:00 CET',
    bulkImportDesc: 'Importēt pasūtījumus no Excel/CSV failiem',
    importOrders: 'Importēt pasūtījumus',
  },
  products: {
    title: 'Produktu saraksts',
    subtitle: 'Biznesa partneris',
    searchPlaceholder: 'Meklēt pēc produkta nosaukuma vai SKU...',
    productId: 'Produkta ID',
    addToCart: 'Pievienot grozam',
    selectVariation: 'Izvēlēties variantu',
    price: 'Cena',
    priceNetNotice: 'Visas cenas ir neto cenas',
    stock: 'Krājumi',
    color: 'Krāsa',
    newProducts: 'Jaunie Produkti',
    newProductBadge: 'JAUNS',
    size: 'Izmērs',
    quantity: 'Daudzums',
    total: 'Kopā',
    cart: 'Grozs',
    checkout: 'Noformēt',
    csvMode: 'CSV ātrais režīms',
    csvInfo: 'Produktu dati iegūti no CSV datiem',
    csvUploadDate: 'CSV augšupielādes datums:',
    stockNote: '※ Krājumu informācija tiek iegūta, izvēloties produkta variantus',
    noProducts: 'Produkti nav atrasti',
    noProductsDesc: 'Mainiet meklēšanas kritērijus vai augšupielādējiet CSV failu ātrākai veiktspējai.',
    retry: 'Mēģināt vēlreiz',
    pagination: 'vienumi',
    variations: 'varianti',
    stockFetchError: 'Krājumu iegūšanas kļūda',
    stockFetchFailed: 'Krājumu iegūšana neizdevās',
    stockFetchFailedDesc: 'Nevarēja iegūt krājumu informāciju. Tiks parādīti CSV krājumi.',
    stockFetched: 'Krājumu informācija iegūta',
    totalStock: 'Kopējie krājumi',
    noStockAll: 'Visiem variantiem ir nulle krājumu',
    noStockData: 'Nav atgriezti krājumu dati',
    stockFetchErrorDesc: 'Iegūstot krājumu informāciju, radās kļūda',
    selectionError: 'Atlases kļūda',
    enterQuantity: 'Lūdzu, ievadiet daudzumu',
    addedToCart: 'Pievienots grozam',
    typesAdded: ' produktu veidi pievienoti',
    addToCartError: 'Kļūda pievienojot grozam',
    addToCartErrorDesc: 'Lūdzu, mēģiniet vēlreiz',
    loadingStock: 'Ielādē krājumu informāciju',
    csvDataInfo: 'Rāda CSV datu informāciju (nevis faktiskos krājumu līmeņus)',
    invalidDataFormat: 'Produkta datu formāts nav derīgs',
    loadFailed: 'Neizdevās ielādēt produkta datus',
    csvUploadComplete: 'CSV augšupielāde pabeigta',
    csvLoadedDesc: ' produktu dati ielādēti. Krājumu informācija tiks iegūta, izvēloties produktus.',
    searchTitle: 'Produktu meklēšana',
    loadingProducts: 'Ielādē produktu datus',
    noProductsCsv: 'CSV datos nav atrastu produktu. Lūdzu, mainiet meklēšanas kritērijus.',
    paginationDisplay: ' parādīti',
    previous: 'Iepriekšējais',
    next: 'Nākamais',
    selectionSummary: 'Atlases kopsavilkums',
    selectedQuantity: 'Atlasītais daudzums',
    items: ' vienumi',
    viewDetails: 'Skatīt detaļas',
    productImage: 'Produkta attēls',
    correspondingVariations: 'Atbilstošie varianti',
    clickToEnlarge: 'Noklikšķiniet, lai palielinātu',
    productIdLabel: 'Produkta ID',
    colorLabel: 'Krāsa',
    filterByCategory: 'Filtrēt pēc kategorijas',
    allProducts: 'Visi produkti',
    applyFilters: 'Lietot filtrus',
    clearFilters: 'Notīrīt filtrus',
    filters: 'Filtri',
    clearAll: 'Notīrīt visu',
  },
  categories: {
    category_21: 'Pirkstu zeķes',
    category_23: 'Bez kategorijas',
    category_24: 'Ķermeņa apģērbs',
    category_29: 'B2B produkti',
  },
  productDetail: {
    title: 'Produkta detaļas',
    backToProducts: 'Atpakaļ uz produktiem',
    productNotFound: 'Produkts nav atrasts',
    productNotFoundDesc: 'Norādītais produkts nepastāv vai ir dzēsts.',
    loading: 'Ielādē produktu...',
    imageLoadError: 'Neizdevās ielādēt attēlus',
    noImages: 'Nav pieejamu attēlu',
    productDescription: 'Produkta apraksts',
    colors: 'Krāsas',
    sizes: 'Izmēri',
    colorCount: 'krāsas',
    sizeCount: 'izmēri',
    variationCount: 'varianti',
    selectVariation: 'Izvēlēties variantus',
    descriptionLanguageNote: '※ Produktu apraksti pieejami tikai angļu vai vācu valodā',
  },
  colors: {
    schwarz: 'Melns',
    weiß: 'Balts',
    grau: 'Pelēks',
    rot: 'Sarkans',
    blau: 'Zils',
    grün: 'Zaļš',
    gelb: 'Dzeltens',
    rosa: 'Rozā',
    lila: 'Violets',
    braun: 'Brūns',
    orange: 'Oranžs',
    beige: 'Bēšs',
    navy: 'Tumši zils',
    dunkelblau: 'Tumši zils',
    hellblau: 'Gaiši zils',
    dunkelgrau: 'Tumši pelēks',
    hellgrau: 'Gaiši pelēks',
    bordeaux: 'Bordo',
    türkis: 'Tirkīza',
    khaki: 'Haki',
    mint: 'Piparmētru',
    violett: 'Violets',
    anthrazit: 'Antracīts',
    blaugrau: 'Zilpelēks',
    burgunderrot: 'Burgundijas sarkans',
    elfenbein: 'Ziloņkauls',
    karminrot: 'Karmīnsarkans',
    neongrün: 'Neona zaļš',
    gelbgrün: 'Dzeltenīgi zaļš',
    pistazie: 'Pistāciju',
    // Angļu krāsu nosaukumi (izmantoti Product ID 237, utt.)
    blue: 'Zils',
    ivory: 'Fildskauls',
    green: 'Zaļš',
    gold: 'Zelts',
    red: 'Sarkans',
  },
  checkout: {
    title: 'Noformēšana',
    cartReview: 'Pasūtījuma pārskats',
    orderSummary: 'Pasūtījuma kopsavilkums',
    shippingInfo: 'Piegādes informācija',
    billingInfo: 'Norēķinu informācija',
    orderNotes: 'Pasūtījuma piezīmes',
    orderNotesPlaceholder: 'Īpaši pieprasījumi vai piezīmes...',
    contactPerson: 'Kontaktpersona',
    phoneNumber: 'Tālruņa numurs',
    email: 'E-pasta adrese',
    company: 'Uzņēmums',
    address: 'Adrese',
    city: 'Pilsēta',
    postalCode: 'Pasta indekss',
    country: 'Valsts',
    deliveryDate: 'Piegādes datums',
    urgentDelivery: 'Ekspress piegāde (3-5 darba dienas)',
    standardDelivery: 'Standarta piegāde (7-10 darba dienas)',
    placeOrder: 'Veikt pasūtījumu',
    backToCart: 'Atpakaļ uz produktu izvēli',
    requiredField: 'Obligāts lauks',
    orderTotal: 'Pasūtījuma summa',
    subtotal: 'Starpsumma',
    priceNetNotice: 'Visas cenas ir neto cenas',
    stockReservationNotice: 'Krājumu rezervācija tiks veikta pēc pasūtījuma apstiprināšanas.',
    stockCheckError: 'Krājumu pārbaudes kļūda',
    stockCheckErrorDesc: 'Krājumu pārbaudes laikā radās kļūda. Lūdzu, mēģiniet vēlreiz.',
    shipping: 'Piegāde',
    shippingCost: 'Piegādes izmaksas',
    tax: 'Nodoklis',
    orderSuccess: 'Pasūtījums veiksmīgs',
    orderSuccessMessage: 'Jūsu pasūtījums ir veiksmīgi iesniegts. Pasūtījuma numurs: {orderNumber}',
    orderNumber: 'Pasūtījuma numurs',
    thankYou: 'Paldies par jūsu pasūtījumu!',
    orderConfirmation: 'Jūsu pasūtījums ir veiksmīgi iesniegts.',
    orderProcessing: 'Pēc mūsu komandas pārskatīšanas mēs nosūtīsim jums pasūtījuma apstiprinājumu pa e-pastu.',
    orderProcessingMessage: 'Jūsu pasūtījums ir veiksmīgi iesniegts. Pēc mūsu komandas pārskatīšanas mēs nosūtīsim jums pasūtījuma apstiprinājumu pa e-pastu.',
    continueShopping: 'Turpināt iepirkties',
    emptyCart: 'Jūsu grozs ir tukšs',
    emptyCartMessage: 'Lūdzu, pievienojiet produktus savam grozam, lai turpinātu',
    stockWarning: 'Krājumu brīdinājums',
    stockWarningDesc: 'Dažiem priekšmetiem nav pietiekamu krājumu. Lūdzu, pielāgojiet daudzumus.',
    stockError: 'Krājumu kļūda',
    stockErrorDesc: 'Ir priekšmeti ar nepietiekamiem krājumiem. Lūdzu, pielāgojiet daudzumus.',
    refreshStock: 'Atsvaidzināt krājumus',
    stockUpdated: 'Krājumi atjaunināti',
    stockUpdatedDesc: 'Krājumi ir atjaunināti - {changed} priekšmeti mainīti',
    stockCheckDesc: 'Salīdzināšanas rezultāti ar krājumiem tiek parādīti',
    stockOk: 'Krājumi OK',
    stockShortage: 'Krājumu trūkums',
    requestedQty: 'Pieprasītais daudzums',
    currentStock: 'Pašreizējie krājumi',
    stockShortageMsg: 'Nepietiekami krājumi. Lūdzu, pielāgojiet daudzumu.',
    stockIssueWarning: 'Pasūtījumu nevar apstiprināt krājumu problēmu dēļ.',
    stockDataMissing: 'Krājumu dati tiek iegūti. Lūdzu, uzgaidiet brīdi.',
    outOfStock: 'Nav noliktavā.',
    maxAvailable: 'Maksimāli',
    autoRestored: 'Grozs atjaunots',
    autoRestoredDesc: 'Jūsu pēdējās sesijas preces ir atjaunotas',
    maxQuantityReached: 'Sasniegts maksimālais krājumu daudzums.',
    // ERP Contact Search
    contactSearch: 'Klienta kontakta meklēšana',
    contactSearchDesc: 'Ievadiet pasūtītāja e-pasta adresi, lai iegūtu kontaktinformāciju',
    emailAddress: 'E-pasta adrese',
    searchButton: 'Meklēt',
    searching: 'Meklē',
    contactFound: 'Kontakts atrasts',
    contactNotFound: 'Kontakts nav atrasts',
    contactId: 'Knitido klienta ID',
    companyName: 'Uzņēmums',
    contactPersonLabel: 'Kontaktpersona',
    addressesFound: 'Atrastas adreses',
    addressType: 'Tips',
    addressBilling: 'Norēķinu adrese',
    addressDelivery: 'Piegādes adrese',
    vatSourceCompany: 'Uzņēmuma info',
    vatSourceBilling: 'Norēķini',
    vatSourceDelivery: 'Piegāde',
    addressOther: 'Cits',
    addressDetails: 'Adrese',
    loadingAddresses: 'Ielādē adreses informāciju...',
    addressRetrieved: 'Adreses informācija iegūta',
    addressNotFound: 'Adreses informācija nav atrasta',
    addressNotFoundDesc: 'Nav reģistrētas adreses informācijas. Lūdzu, ievadiet manuāli.',
    addressError: 'Adreses iegūšanas kļūda',
    addressErrorDesc: 'Neizdevās iegūt adreses informāciju.',
    contactNotConfirmed: 'Klienta kontakts nav apstiprināts',
    contactNotConfirmedDesc: 'Lūdzu, ievadiet e-pasta adresi un meklējiet kontaktu.',
    searchContact: 'Meklēt kontaktu',
    inputError: 'Ievades kļūda',
    inputErrorDesc: 'Piegādes informācija ir nepilnīga. Lūdzu, pārbaudiet.',
    processing: 'Apstrādā...',
    erpContactSearch: 'Klienta kontakta meklēšana',
    contactSearchError: 'E-pasta adrese neatbilst nevienam reģistrētam kontaktam.',
    // Product Images Toggle
    showProductImages: 'Rādīt produktu attēlus',
    showProductImagesDesc: 'Parādīt produktu attēlus labākam pārskatam (var palielināt ielādes laiku)',
    // System Registration Info
    systemRegistrationInfo: 'Jūsu klienta informācija',
    editShippingAddress: 'Rediģēt piegādes adresi',
    systemRegistrationInfoDesc: 'Jūsu reģistrētā biznesa informācija. Lūdzu, sazinieties ar savu pārstāvi, ja jums jāatjaunina norēķinu adreses informācija.',
    // Order Summary
    regularPrice: 'Parastā vairumtirdzniecības cena',
    offeredPrice: 'Piedāvātā cena',
    discount: 'Atlaide',
    b2bCustomer: 'B2B klients',
    pattern: 'Modelis',
    specialPriceApplied: 'Piemērota īpašā cena',
    customerClassification: 'Klienta klasifikācija',
    paymentCondition: 'Maksājuma nosacījumi',
    invoice: 'Rēķins (NET 30)',
    prepayment: 'Priekšapmaksa',
    paymentMethod: 'Maksājuma veids',
    invoicePayment: 'Rēķina maksājums',
    estimatedSubtotal: 'Aptuvena starpsumma',
    estimatedTotal: 'Aptuvena kopsumma',
    orderSummaryDisclaimer: 'Šeit rādītās cenas ir aptuvenas. Kad saņemsim jūsu pasūtījumu, mēs to pārskatīsim un nosūtīsim jums saistošu pasūtījuma apstiprinājumu ar galīgajām cenām, piegādes izmaksām un nodokļiem pa e-pastu.',
    searchError: 'Meklēšanas kļūda',
    searchErrorDesc: 'Kontakta meklēšanas laikā radās kļūda.',
    confirmDeleteItem: 'Noņemt priekšmetu',
    itemDeleted: 'Priekšmets noņemts',
    confirmDeleteItemDesc: 'Vai tiešām vēlaties noņemt šo priekšmetu no sava groza?',
    deleteConfirm: 'Noņemt',
    contactNotes: 'Kontakta piezīmes',
    contactNotesDesc: 'Vai jums ir kādi jautājumi vai īpaši pieprasījumi? Lūdzu, informējiet mūs (neobligāti)',
    contactNotesLabel: 'Ziņojums',
    contactNotesPlaceholder: 'piemēram: Produkta jautājumi, īpašas prasības utt.',
    characters: 'rakstzīmes',
    contactIdLabel: 'Knitido klienta ID',
    companyLabel: 'Uzņēmums',
    personLabel: 'Kontaktpersona',
    emailLabel: 'E-pasts',
    addressTypeLabel: 'Tips',
    destinationLabel: 'Galamērķis',
    // Shipping Form
    shippingTitle: 'Piegādes informācija',
    shippingDesc: 'Ievadiet produktu piegādes adresi',
    companyRequired: 'Uzņēmums *',
    contactPersonRequired: 'Kontaktpersona *',
    emailRequired: 'E-pasta adrese *',
    phoneRequired: 'Tālruņa numurs *',
    addressRequired: 'Adrese 1 *',
    address2: 'Adrese 2 (Ēka/Telpa)',
    postalCodeRequired: 'Pasta indekss *',
    cityRequired: 'Pilsēta *',
    countryRequired: 'Valsts *',
    selectCountry: 'Izvēlēties valsti',
    shippingMethodRequired: 'Piegādes veids *',
    selectShippingMethod: 'Izvēlēties piegādes veidu',
    urgentDeliveryOption: 'Ekspress piegāde (papildu maksa)',
    deliveryNotes: 'Piegādes piezīmes',
    deliveryNotesPlaceholder: 'Ievadiet piegādes laika preferences vai citus pieprasījumus',
    standardShipping: 'Standarta piegāde (3-5 darba dienas)',
    expressShipping: 'Ekspress piegāde (1-2 darba dienas)',
    overnightShipping: 'Nakts piegāde',
    germany: 'Vācija',
    austria: 'Austrija',
    switzerland: 'Šveice',
    japan: 'Japāna',
    shippingAddressLabel: 'Piegādes adrese',
    changeDeliveryAddress: 'Mainīt piegādes adresi',
    selectDeliveryAddress: 'Izvēlēties piegādes adresi',
    // Shipping Cost Details
    freeShipping: 'Bezmaksas piegāde',
    shippingError: 'Kļūda',
    shippingZone: 'Piegādes zona',
    remainingForFreeShipping: 'Vēl {amount} bezmaksas piegādei',
    moreForFreeShipping: 'vairāk bezmaksas piegādei',
    freeShippingProgress: 'Bezmaksas piegāde pie',
    andAboveFreeShipping: 'un vairāk bezmaksas piegādei',
    freeShippingAchieved: 'Piemērota bezmaksas piegāde',
    threshold: 'un vairāk',
    nextShippingTier: 'Nākamā piegādes atlaide',
    moreForDiscount: 'vairāk',
    shippingSavings: 'piegādes ietaupījumiem',
    orderAmountThreshold: 'un vairāk',
    specialRegionNotice: 'Piemērots īpašs piegādes reģions',
    defaultShippingApplied: 'Piemērotas standarta piegādes likmes',
    requestedQuantity: 'Pieprasītais daudzums',
    availableQuantity: 'Pieejamais daudzums',
    orderSubmitError: 'Pasūtījuma kļūda',
    orderSubmitErrorDesc: 'Neizdevās iesniegt pasūtījumu',
    upload: {
      title: 'Importēt Excel/CSV pasūtījumu',
      description: 'Augšupielādējiet Excel vai CSV failu ar jūsu pasūtījuma datiem',
      dragDropOrClick: 'Velciet un nometiet failu šeit vai noklikšķiniet, lai izvēlētos',
      dropHere: 'Nometiet failu šeit',
      supportedFormats: 'Atbalstītie formāti: Excel (.xlsx, .xls) un CSV (.csv)',
      maxSize: 'Maksimālais faila izmērs: {size} MB',
      processFile: 'Apstrādāt failu',
      processing: 'Apstrādā failu...',
      ready: 'Fails gatavs priekšskatījumam',
      readyDescription: 'Jūsu fails ir veiksmīgi apstrādāts un ir gatavs pārskatīšanai.',
      preview: 'Rādīt priekšskatījumu',
      errors: {
        fileTooLarge: 'Fails ir pārāk liels. Maksimālais izmērs: {size} MB',
        invalidFileType: 'Nederīgs faila tips. Lūdzu, augšupielādējiet Excel vai CSV failu',
        uploadFailed: 'Kļūda augšupielādējot failu',
      },
    },
    // Loading messages
    loadingPage: 'Ielādē lapu...',
    loadingStock: 'Pārbauda produktu krājumus...',
    loadingAccount: 'Ielādē konta informāciju...',
    loadingError: 'Radās kļūda...',
    loadingData: 'Ielādē datus',
    // Toast messages
    addressRetrievedTitle: 'Adreses informācija iegūta',
    addressSetAsDelivery: ' adrese iestatīta kā piegādes galamērķis.',
    contactFoundDesc: ' tika atpazīts.'
  },
  orderHistory: {
    title: 'Pasūtījumu vēsture',
    searchPlaceholder: 'Meklēt pēc pasūtījuma numura vai SKU...',
    noOrders: 'Nav atrastu pasūtījumu',
    noOrdersFound: 'Nav atrastu atbilstošu pasūtījumu',
    startShopping: 'Skatīt produktus',
    orderItems: 'Pasūtījuma priekšmeti',
    viewDetails: 'Detaļas',
    reorder: 'Pasūtīt atkārtoti',
    orderDate: 'Pasūtījuma datums',
    orderStatus: 'Statuss',
    orderTotal: 'Pasūtījuma summa',
    // Status translations
    statusPending: 'Gaida maksājumu',
    statusProcessing: 'Apstrādā',
    statusConfirmed: 'Apstiprināts',
    statusShipped: 'Nosūtīts',
    statusDelivered: 'Piegādāts',
    statusCancelled: 'Atcelts',
    statusReturned: 'Atgriezts',
    statusRefunded: 'Atmaksāts',
    statusWarranty: 'Garantija',
    statusExchanged: 'Apmainīts',
    statusRepair: 'Remonts',
    statusUnknown: 'Nezināms',
    statusIncomplete: 'Nepabeigts',
    statusWaitingPayment: 'Gaida maksājumu',
    statusInPreparation: 'Sagatavošanā',
    statusClearedShipping: 'Atbrīvots piegādei',
    statusBeingShipped: 'Tiek nosūtīts',
    statusOutgoingBooked: 'Izejošais rezervēts',
    statusReturn: 'Atgriešana',
    // Additional UI elements
    itemCount: 'priekšmeti',
    itemCountSingular: 'priekšmets',
    refreshButton: 'Atsvaidzināt',
    errorFetchingOrders: 'Neizdevās iegūt pasūtījumu vēsturi',
    // Payment status features
    paymentStatus: 'Maksājuma statuss',
    markAsPaid: 'Atzīmēt kā apmaksātu',
    unmarkAsPaid: 'Noņemt apmaksas atzīmi',
    paidOn: 'Apmaksāts',
    paymentMarked: 'Apmaksāts',
    notPaid: 'Nav apmaksāts',
    paymentMarkedSuccess: 'Veiksmīgi atzīmēts kā apmaksāts',
    paymentUnmarkedSuccess: 'Maksājuma atzīme noņemta',
    paymentUpdateError: 'Neizdevās atjaunināt maksājuma statusu',
    // Payment date dialog
    paymentDateTitle: 'Ievadīt maksājuma informāciju',
    paymentDateDescription: 'Ievadiet maksājuma informāciju pasūtījumam {orderNumber}',
    paymentDateLabel: 'Maksājuma datums',
    selectDate: 'Izvēlēties datumu',
    paymentDateHelp: 'Izvēlieties datumu, kad tika veikts bankas pārskaitījums',
    paymentMethodLabel: 'Maksājuma veids',
    bankTransfer: 'Bankas pārskaitījums',
    invoice: 'Rēķins',
    otherPayment: 'Cits',
    paymentReferenceLabel: 'Pārskaitījuma nosaukums / Atsauces numurs',
    paymentReferencePlaceholder: 'piemēram, Jānis Bērziņš, Pārskaitījums #12345',
    paymentReferenceHelp: 'Ievadiet informāciju, kas palīdz saskaņot ar bankas pārskatiem',
    notesLabel: 'Piezīmes',
    notesPlaceholder: 'Ievadiet jebkādu papildu maksājuma informāciju',
    // Filter options
    filterByPaymentStatus: 'Filtrēt pēc maksājuma statusa',
    allOrders: 'Visi pasūtījumi',
    paidOrders: 'Apmaksāti',
    unpaidOrders: 'Neapmaksāti',
    // Sorting options
    sortBy: 'Kārtot pēc',
    sortByDate: 'Pasūtījuma datuma',
    sortByPaymentDate: 'Maksājuma datuma',
    sortByAmount: 'Summas',
    sortByStatus: 'Statusa',
  },
  orderDetails: {
    title: 'Pasūtījuma detaļas',
    notFound: 'Pasūtījums nav atrasts',
    backToHistory: 'Atpakaļ uz pasūtījumu vēsturi',
    orderDate: 'Pasūtījuma datums',
    orderItems: 'Pasūtījuma priekšmeti',
    deliveryStatus: 'Piegādes statuss',
    estimatedDelivery: 'Paredzamā piegāde',
    deliveredOn: 'Piegādāts',
    downloadInvoice: 'Lejupielādēt rēķinu',
    statusDelivered: 'Piegādāts',
    statusShipped: 'Nosūtīts',
    statusConfirmed: 'Apstiprināts',
    statusCancelled: 'Atcelts',
    errorFetchingDetails: 'Neizdevās iegūt pasūtījuma detaļas',
  },
  company: {
    name: 'Biznesa partneris',
    tagline: 'Biznesa partnera sistēma',
    copyright: '© 2025 Biznesa partnera sistēma. Visas tiesības aizsargātas.',
  },
  footer: {
    phone: 'Tālrunis',
    email: 'E-pasts',
    countries: {
      DE: 'Vācija',
      AT: 'Austrija',
      CH: 'Šveice',
      FR: 'Francija',
      IT: 'Itālija',
      ES: 'Spānija',
      NL: 'Nīderlande',
      BE: 'Beļģija',
      PL: 'Polija',
      SE: 'Zviedrija',
      NO: 'Norvēģija',
      FI: 'Somija',
      DK: 'Dānija',
      LT: 'Lietuva',
      LV: 'Latvija',
      EE: 'Igaunija',
    },
  },
  cart: {
    newCart: 'Jauns grozs',
    currentCart: 'Pašreizējais grozs',
    modified: 'modificēts',
    lastSaved: 'Pēdējoreiz saglabāts',
    unsavedChanges: 'nesaglabātas izmaiņas',
    saveCart: 'Saglabāt grozu',
    loadCart: 'Ielādēt grozu',
    deleteCart: 'Dzēst grozu',
    startNewCart: 'Sākt jaunu grozu',
    savedCarts: 'Saglabātie grozi',
    cartSaved: 'Grozs saglabāts',
    cartDeleted: 'Grozs dzēsts',
    confirmDeleteCart: 'Dzēst grozu?\n\nŠo darbību nevar atsaukt.',
    confirmSwitchCart: 'Pašreizējam grozam ir nesaglabātas izmaiņas.\n\nIelādējot citu grozu, pašreizējās izmaiņas tiks zaudētas.\n\nTurpināt?',
    confirmSwitchCartTitle: 'Pārslēgt grozu',
    confirmNewCart: 'Pašreizējam grozam ir nesaglabātas izmaiņas.\n\nSākot jaunu grozu, pašreizējās izmaiņas tiks zaudētas.\n\nTurpināt?',
    confirmNewCartTitle: 'Sākt jaunu grozu',
    confirmClearCart: 'Notīrīt grozu?\n\n{count} priekšmeti tiks noņemti.\n\nŠo darbību nevar atsaukt.',
    confirmClearCartTitle: 'Notīrīt grozu',
    autoSaved: 'Automātiski saglabāts',
    itemsWillBeRemoved: 'priekšmeti tiks noņemti',
    changesWillBeLost: 'izmaiņas tiks zaudētas',
    continueQuestion: 'Turpināt?',
    cartStatus: 'Groza statuss',
    cartName: 'Groza nosaukums',
    cartNamePlaceholder: 'piemēram: Mēneša beigu pasūtījums',
    cartNameRequired: 'Lūdzu, ievadiet groza nosaukumu',
    saveCartDescription: 'Piešķiriet pašreizējam grozam nosaukumu un saglabājiet to. Vēlāk varēsiet to ielādēt.',
    cancelCart: 'Atcelt grozu',
    proceedToCheckout: 'Doties uz noformēšanu',
    emptyCart: 'Grozs ir tukšs',
    erpDown: 'Pasūtījumu sistēma nedarbojas. Lūdzu, mēģiniet vēlāk vēlreiz.',
    erpDegraded: 'Sistēma pašlaik ir nestabila. Pasūtījumi var neizdoties.',
    erpDownSaveHint: 'Saglabājiet grozu un pasūtiet pēc sistēmas atjaunošanas.',
    erpSaveCart: 'Saglabāt grozu',
  },
  nav: {
    dashboard: 'Vadības panelis',
    products: 'Produkti',
    orderHistory: 'Pasūtījumu vēsture',
    account: 'Konta info',
    bulkImport: 'Masveida imports',
  },
  settings: {
    selectLanguage: 'Izvēlieties valodu',
    languagePreferenceSaved: 'Jūsu preference tiks saglabāta jūsu kontā turpmākiem apmeklējumiem.',
  },
  reorder: {
    allItemsAdded: '{count} priekšmeti pievienoti grozam',
    partialSuccess: '{added} priekšmeti pievienoti. {failed} priekšmetus nevarēja pievienot',
    allItemsFailed: 'Neizdevās pievienot priekšmetus grozam',
    error: 'Atkārtotas pasūtīšanas laikā radās kļūda',
    itemDiscontinued: '{name} ({color}/{size}) ir pārtraukts',
    itemOutOfStock: '{name} ({color}/{size}) nav noliktavā',
    partialStock: '{name} ({color}/{size}) tikai {available} pieejami',
    confirmReorder: 'Apstiprināt atkārtotu pasūtījumu',
    confirmReorderMessage: 'Pievienot priekšmetus no šī pasūtījuma savam grozam?',
    addingToCart: 'Pievieno grozam...',
    checkingStock: 'Pārbauda krājumus...',
    checkoutTitle: 'Priekšmeti pievienoti grozam',
    checkoutDescription: '{count} priekšmeti ir pievienoti jūsu grozam. Vai vēlaties doties uz noformēšanu?',
  },
  bulkImport: {
    instructions: 'Kā importēt pasūtījumus',
    step1: 'Lejupielādējiet pasūtījuma veidnes failu',
    step2: 'Aizpildiet savus pasūtījuma datus ar SKU un daudzumu',
    step3: 'Saglabājiet kā Excel (.xlsx) vai CSV failu',
    step4: 'Augšupielādējiet failu, izmantojot zemāk esošo formu',
    step5: 'Pārskatiet un apstipriniet savu pasūtījumu',
    downloadTemplate: 'Lejupielādēt veidni',
    downloadExcelTemplate: 'Lejupielādēt Excel veidni',
    downloadCsvTemplate: 'Lejupielādēt CSV veidni',
    formatGuide: 'Faila formāta rokasgrāmata',
    requiredColumns: 'Obligātās kolonnas',
    skuDescription: 'Produkta SKU kods',
    quantityDescription: 'Pasūtījuma daudzums (pozitīvs vesels skaitlis)',
    optionalColumns: 'Papildu kolonnas',
    notesDescription: 'Iekšējās piezīmes (piemēram, PO numurs, atsauce) - tikai jūsu ierakstiem',
    formatNote: 'Pirmajā rindā jābūt kolonnu virsrakstiem. Dati sākas no otrās rindas.',
    parseSuccess: 'Veiksmīgi parsēti {count} priekšmeti no faila',
    parseError: 'Parsēšanas kļūda',
    validationError: 'Validācijas kļūdas',
    validationErrorGuidance: 'Lūdzu, noklikšķiniet uz pogas “{showPreviewButton}”, lai pārskatītu detaļas.',
    warnings: 'Brīdinājumi',
    itemsParsed: 'Veiksmīgi parsēti {count} priekšmeti:',
    andMore: '...un vēl {count} priekšmeti',
    validationSummary: 'Validācijas kopsavilkums',
    duplicateSKUs: 'Atrasti dublikāti SKU',
    skuFormat: 'SKU jāsatur tikai burti, cipari un domuzīmes',
    quantityRange: 'Daudzumam jābūt starp 1 un 9999',
    maxRows: 'Maksimāli 1000 rindas atļautas',
    rowsSkipped: '{count} rindas tika izlaistas kļūdu dēļ',
    previewTitle: 'Pasūtījuma priekšskatījums',
    previewDescription: 'Pārskatiet un rediģējiet savus pasūtījuma datus pirms turpināšanas',
    proceedToCart: 'Pievienot grozam',
    // File parsing messages
    fileEmpty: 'Fails ir tukšs vai nesatur datus',
    fileTooManyRows: 'Fails satur pārāk daudz rindu ({current}). Maksimāli atļauts: {max}',
    invalidRowFormat: 'Nederīgs rindas formāts',
    missingColumns: 'Trūkst obligātās kolonnas (SKU un Daudzums)',
    missingSku: 'Trūkst SKU',
    invalidSkuFormat: 'Nederīgs SKU formāts: "{sku}" (jāatbilst modelim: {pattern})',
    skuTooLong: 'SKU pārāk garš: "{sku}" (maksimāli 50 rakstzīmes)',
    invalidQuantity: 'Nederīgs daudzums: "{quantity}" nav skaitlis',
    quantityTooLow: 'Daudzums pārāk mazs: {quantity} (minimums: {min})',
    quantityTooHigh: 'Daudzums pārāk liels: {quantity} (maksimums: {max})',
    notesRequired: 'Piezīmju lauks ir obligāts',
    noValidData: 'Nav atrasti derīgi dati. Lūdzu, pārbaudiet sava faila formātu.',
    row: 'Rinda {row}: {errors}',
    rowErrors: '...un vēl {count} kļūdas',
    duplicateSkuInRows: 'Dublikāts SKU "{sku}" atrasts rindās: {rows}',
    quantityExceedsMax: 'Rinda {row}: Daudzums {quantity} pārsniedz maksimāli atļauto ({max})',
    quantityBelowMin: 'Rinda {row}: Daudzums {quantity} ir zem minimāli nepieciešamā ({min})',
    // Validation messages
    unsupportedFileFormat: 'Neatbalstīts faila formāts. Lūdzu, augšupielādējiet CSV vai Excel failu.',
    csvParsingErrors: 'Radās CSV parsēšanas kļūdas',
    failedToParseFile: 'Neizdevās parsēt failu',
    failedToParseExcel: 'Neizdevās parsēt Excel failu',
    failedToReadFile: 'Neizdevās nolasīt failu',
    unknownError: 'Radās nezināma kļūda',
    totalRows: 'Kopā rindas',
    valid: 'Derīgs',
    invalid: 'Nederīgs',
    skipped: 'Izlaists',
    // SKU validation
    skuValidationError: 'SKU validācijas kļūda',
    skuValidationFailed: 'Neizdevās validēt SKU. Jūs joprojām varat turpināt, bet daži priekšmeti var nebūt pieejami.',
    skuNotFound: 'SKU nav atrasts datu bāzē',
    skusNotFound: '{count} SKU nav atrasti datu bāzē',
    itemsHaveInsufficientStock: '{count} precēm ir nepietiekams krājums',
    validatingSKUs: 'Pārbauda preces...',
    unvalidatedChanges: 'Jums ir nevalidētas izmaiņas. Lūdzu, validējiet vēlreiz pirms pievienošanas grozam.',
    revalidate: 'Validēt vēlreiz',
    validating: 'Validē...',
    validationSuccess: 'Visas preces ir derīgas',
    validationComplete: 'Validācija pabeigta',
    validationResultSummary: '{errors} kļūdas, {warnings} brīdinājumi atrasti',
    // Table headers
    actions: 'Darbības',
    notes: 'Piezīmes',
    // Status filter
    all: 'Visi',
    hasErrors: 'Ar kļūdām',
    // Selection summary
    selected: 'atlasīts',
    errors: 'kļūdas',
    // Pagination
    page: 'Lapa {current} no {total}',
    previous: 'Iepriekšējā',
    next: 'Nākamā',
    noResults: 'Nav rezultātu.',
    // Cart integration
    noValidItems: 'Nav derīgu priekšmetu',
    allItemsHaveErrors: 'Visiem priekšmetiem ir validācijas kļūdas. Lūdzu, izlabojiet tās pirms turpināšanas.',
    dataLoadingError: 'Datu ielādes kļūda',
    failedToLoadProductData: 'Neizdevās ielādēt produkta datus. Lūdzu, mēģiniet vēlreiz.',
    itemsAddedToCart: '{count} priekšmeti pievienoti grozam',
    itemsAddedMessage: 'Pievienoti {count} priekšmeti grozam',
    someSkusNotFound: '{count} SKU nevarēja atrast.',
    noItemsAdded: 'Nav pievienotu priekšmetu',
    couldNotFindProducts: 'Nevarēja atrast nevienu produktu, kas atbilstu SKU.',
    errorAddingToCart: 'Kļūda',
    failedToAddToCart: 'Neizdevās pievienot priekšmetus grozam. Lūdzu, mēģiniet vēlreiz.',
    addingToCart: 'Pievieno grozam...',
    // File info
    fileSelected: '{name} izvēlēts apstrādei',
    fileSize: '{size} baiti',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Veidnes lejupielāde',
    templateWillBeImplemented: 'Veidnes lejupielāde tiks ieviesta 7. fāzē',
    // Additional validation
    validationFailed: 'Validācija neizdevās',
    // Template download
    templateDownloaded: 'Veidne veiksmīgi lejupielādēta',
    templateDownloadError: 'Neizdevās lejupielādēt veidni',
    // Template content
    sheetName: 'Masveida pasūtījums',
    instructionsSheetName: 'Instrukcijas',
    columnDescriptions: 'Kolonnu apraksti:',
    columnHeader: 'Kolonna',
    columnRequired: 'Obligāts',
    columnOptional: 'Papildu',
    columnDescription: 'Apraksts',
    templateNotes: 'Piezīmes:',
    templateNote1: 'Pirmajā rindā jābūt kolonnu virsrakstiem tieši kā parādīts',
    templateNote2: 'Dati sākas no 2. rindas',
    templateNote3: 'SKU jāatbilst esošajiem produktu kodiem sistēmā',
    templateNote4: 'Daudzumam jābūt pozitīvam veselam skaitlim starp 1 un 9999',
    templateNote5: 'Maksimāli 1000 rindas atļautas vienā failā',
    templateNote6: 'Saglabājiet .xlsx vai .csv formātā',
    stockAvailabilityWarning: 'Faktiskā krājumu pieejamība tiks pārbaudīta nākamajā norēķinu lapā.',
    outOfStock: 'Nav noliktavā',
    insufficientStock: 'Nepietiekams krājums: {available} pieejams, {requested} pieprasīts',
  },
  orderExport: {
    export: 'Eksportēt pasūtījumu',
    exportOrder: 'Eksportēt pasūtījuma datus',
    exportAsCSV: 'Eksportēt kā CSV',
    exportAsExcel: 'Eksportēt kā Excel',
    exportForReorder: 'Eksportēt masveida importam',
    detailed: 'Pilnas detaļas',
    simpleFormat: 'Importa formāts',
  },
};